export const getTextFromLanguage = (text: any, langCode: string) => {
  try {        
    return text.find((e: any) => e.langCode === langCode).content
  } catch (error) {
    return null
  }
}
